// extracted by mini-css-extract-plugin
module.exports = {"root":"VideoSuggestionsPanel_root__3n_ns","title":"VideoSuggestionsPanel_title__2Chox","list":"VideoSuggestionsPanel_list__22Nly"};